var data = {
	"body": "<path fill=\"currentColor\" d=\"M19 20.75l-2.31-9A5.94 5.94 0 0 0 18 8A6 6 0 0 0 6 8a5.94 5.94 0 0 0 1.34 3.77L5 20.75a1 1 0 0 0 1.48 1.11l5.33-3.13l5.68 3.14A.91.91 0 0 0 18 22a1 1 0 0 0 1-1.25zM12 4a4 4 0 1 1-4 4a4 4 0 0 1 4-4z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
